const statusValue = (request) => String(request?.status || request?.rawStatus || "").toUpperCase();

export const getRejectionReason = (request) => {
    if (statusValue(request) !== "REJECTED") return null;

    const reasons = request?.adminDecision === false
        ? [request?.adminComment, request?.motifRejet, request?.rejectionReason, request?.managerComment]
        : request?.managerDecision === false
            ? [request?.managerComment, request?.motifRejet, request?.rejectionReason, request?.adminComment]
            : [request?.motifRejet, request?.rejectionReason, request?.adminComment, request?.managerComment];

    return reasons.find((reason) => typeof reason === "string" && reason.trim())?.trim() || null;
};

export const getRequestStatusLabel = (request) => {
    switch (statusValue(request)) {
        case "PENDING_MANAGER": return "En attente du manager";
        case "PENDING_ADMIN": return "En attente de l'Admin RH";
        case "APPROVED": return "Approuvée";
        case "REJECTED": return "Rejetée";
        case "CANCELLED": return "Annulée";
        case "POSTPONED": return "Reporté";
        case "REPORTE": return "Reporté";
        case "POSTPONEMENT_REQUEST":
        case "POSTPONED_REQUEST": return "En attente de report";
        default: return request?.status || "En attente";
    }
};

export const getRequestTracking = (request) => {
    const status = statusValue(request);
    if (status === "PENDING_MANAGER") return { label: "En attente chez le manager", actor: null, date: null, reason: null };
    if (status === "PENDING_ADMIN") return { label: "En attente chez l'Admin RH", actor: null, date: null, reason: null };
    if (status === "POSTPONED" || status === "REPORTE") return { label: "Reporté", actor: null, date: null, reason: null };
    if (status === "POSTPONEMENT_REQUEST" || status === "POSTPONED_REQUEST") return { label: "En attente de report", actor: null, date: null, reason: null };

    const handledByAdmin = request?.adminDecision === true || request?.adminDecision === false;
    const actor = handledByAdmin ? request?.adminName : request?.managerName;
    const date = handledByAdmin ? request?.adminDecisionAt : request?.managerDecisionAt;
    const reason = handledByAdmin ? request?.adminComment : request?.managerComment;

    if (status === "APPROVED") return { label: actor ? `Approuvée par ${actor}` : "Approuvée", actor, date, reason: null };
    if (status === "REJECTED") return { label: actor ? `Rejetée par ${actor}` : "Rejetée", actor, date, reason };
    return { label: "—", actor: null, date: null, reason: null };
};
